import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { NotFoundScreen } from '../../components/alliance/system-screens';

/**
 * Unknown routes render the 404 inside the shell (the App Bar stays usable)
 * instead of silently redirecting home. It skips RouteContainer, so no page
 * header, banner carousel or footer sits around the screen.
 */
export function NotFound() {
  // Hooks
  const navigate = useNavigate();

  return (
    <Box role="main" sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
      <Helmet>
        <title>ARC · Page not found</title>
      </Helmet>

      <NotFoundScreen onHome={() => navigate('/home')} />
    </Box>
  );
}
